import {filter, reduce, toLower} from 'lodash';

export function computeSkillLevel (skill, skills_data) {
    const this_skills_data = filter(skills_data, {practice_skill_code: skill.code});
    const xpRule = (xp, skill_data) => {
        const score = Math.round(skill_data.achievement_percentage);
        // const score = Math.round(skill_data.potential_percentage);
        return xp + score * 7 + 100;
    }
    const total_xp = reduce(this_skills_data, xpRule, 0);

    const level = Math.floor(total_xp / 1000) + 1;
    const remain_xp = total_xp % 1000;
    const xp_percentage = Math.round(remain_xp / 10);

    const getTier = () => {
        switch (level) {
            case 1:
                return 'bronze';
            case 2:
                return 'silver';
            case 3:
                return 'gold';
            case 4:
            default:
                return 'master';
        }
    }

    const image_url = process.env.PUBLIC_S3_ASSETS_URL
        + `/skills-passport/skill-icon/`
        + 'mindsets_'
        + toLower(skill.code.replace(' ', '_'))
        + '.png';

    return {
        ...skill,
        total_xp,
        level,
        remain_xp,
        xp_percentage,
        tier: getTier(),
        image_url
    }
}

export function computeUserLevel (skills_data) {
    const xpRule = (xp, skill_data) => {
        const score = Math.round(skill_data.achievement_percentage);
        return xp + score * 7 + 100;
    }
    const total_xp = reduce(skills_data, xpRule, 0);
    const level = Math.floor(total_xp / 1000) + 1;
    const remain_xp = total_xp % 1000;
    const xp_percentage = Math.round(remain_xp / 10);

    return {
        total_xp,
        level,
        remain_xp,
        xp_percentage
    }
}